import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type TtbPaymentModuleSpecsFragment } from '../../../../api/fragments/TtbPaymentModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { useTtbPaymentSettingsDrawer } from './TtbPaymentSettingsDrawer';

export type TtbPaymentSettingsEmptyListProps = {
    module: TtbPaymentModuleSpecsFragment;
};

const TtbPaymentSettingsEmptyList = ({ module }: TtbPaymentSettingsEmptyListProps) => {
    const { t } = useTranslation(['ttbPaymentModuleDetails']);
    const addTtbPaymentSettingsDrawer = useTtbPaymentSettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={addTtbPaymentSettingsDrawer.open} type="primary">
                        {t('ttbPaymentModuleDetails:emptyList.paymentSettings.noData.action')}
                    </Button>
                }
                subTitle={t('ttbPaymentModuleDetails:emptyList.paymentSettings.noData.message')}
            />
            {addTtbPaymentSettingsDrawer.render()}
        </>
    );
};

export default TtbPaymentSettingsEmptyList;
